import { ChangeEvent, FunctionComponent, useState } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { Locales } from 'types/locale';
import { Routes } from 'types/routes';

import { select as selectLocale } from 'utils/locale';
import { withVariables } from 'utils/string';

import Button, { ButtonLayouts, ButtonSizes, ButtonStyles, ButtonTypes, ButtonVariants } from 'components/layout/Button';
import Checkbox, { InputStyles as CheckboxStyles } from 'components/layout/forms/Checkbox';
import Form from 'components/layout/forms/Form';
import Input, { InputStyles } from 'components/layout/forms/Input';

import { Props } from './index';
import StyledComponent from './styles';

const PanelFormUserLogin: FunctionComponent<Props> = ({ actions, onSuccess, pageMode }) => {
    const router = useRouter();
    const [errorMessage, setErrorMessage] = useState<string>(null);

    const translations = selectLocale({
        [Locales.En]: require('./locales/en.json'),
        [Locales.Pl]: require('./locales/pl.json'),
    });

    return (
        <StyledComponent className="panel-form-user-login">
            <Form
                submitAction={(values) => {
                    return actions.login({
                        login: values.email,
                        password: values.password,
                    })
                        .catch(error => {
                            setErrorMessage(translations?.error?.label);
                            throw error;
                        });
                }}
                onSuccess={onSuccess}
                errorMessage={errorMessage}
            >
                {({ formik }) => {
                    return (
                        <>
                            <Input
                                name="email"
                                type="text"
                                style={InputStyles.Primary}
                                label={pageMode && translations?.inputs?.email?.label}
                                placeholder={translations?.inputs?.email?.placeholder}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                required={true}
                            />
                            <Input
                                name="password"
                                type="password"
                                style={InputStyles.Secondary}
                                label={pageMode && translations?.inputs?.password?.label}
                                placeholder={translations?.inputs?.password?.placeholder}
                                onChange={formik.handleChange}
                                value={formik.values.password}
                                required={true}
                            />
                            <div className="inputs-additions">
                                <Checkbox
                                    name="rememberMe"
                                    style={CheckboxStyles.Tertiary}
                                    label={translations?.inputs?.rememberMe?.label}
                                    value={formik.values.rememberMe}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        const value = e.target.checked;
                                        formik.setFieldValue('rememberMe', value);
                                    }}
                                />
                                <Button
                                    className="password-reset"
                                    style={ButtonStyles.Gold}
                                    variant={ButtonVariants.Underline}
                                    size={ButtonSizes.Small}
                                    onClick={() => router.push(withVariables(Routes.AccountPasswordReset))}
                                >
                                    {translations?.inputs?.buttons?.passwordChange?.label}
                                </Button>
                            </div>
                            <Button
                                className="form-control"
                                type={ButtonTypes.Submit}
                                layout={ButtonLayouts.Block}
                                size={ButtonSizes.Large}
                                loading={formik.isSubmitting}
                            >
                                {translations?.inputs?.buttons?.submit?.label}
                            </Button>
                            <div className={classnames('form-footer', {
                                'no-absolute': pageMode,
                            })}
                            >
                                <div
                                    className="footer-title"
                                    dangerouslySetInnerHTML={{ __html: withVariables(translations?.footerTitle, { value: Routes.PublicRegulations }) }}
                                />
                            </div>
                        </>
                    );
                }}
            </Form>
        </StyledComponent>
    );
};

export default PanelFormUserLogin;
